import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function DialogueBox({clickDelete, setClickDelete, setConfirmDelete}) {

  return (
    <Dialog
      open={clickDelete}
      // onClose={() => handleClose(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title" sx={{color:"red", textDecoration:"bold"}}>Alert!</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
        Are you sure you want to delete ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {setConfirmDelete(false), setClickDelete(false)}} color="primary" style={{ backgroundColor: '#010160', color: 'white' }}>
          Cancel
        </Button>
        <Button onClick={() => {setConfirmDelete(true),setClickDelete(false)}} color="primary" autoFocus style={{ backgroundColor: '#010160', color: 'white' }}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
